import {
  CREATE_ROLE_SUCCESS,
  FETCH_ROLE_SUCCESS,
  GET_ROLE_SUCCESS,
  REFRESH_ROLE_DATA,
  SAVE_ROLE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ROLE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ROLE_SUCCESS: {
      const query = {...state.query};
      // query.pagination.total = action.count;
      if(query && query.pagination)
        query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ROLE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ROLE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case REFRESH_ROLE_DATA: {
      return {
        ...state,
        edit: {},
      }
    }


    default:
      return state;
  }
}
